/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Faq_Team_AInputs */

const en_platform_faq_team_a = /** @type {(inputs: Platform_Faq_Team_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Everyone gets their own hours and their own clients, on one shared schedule, and nobody can be booked twice for the same hour.`)
};

const pl_platform_faq_team_a = /** @type {(inputs: Platform_Faq_Team_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tak. Każdy ma własne godziny i własnych podopiecznych, w jednym wspólnym grafiku, i nikogo nie da się zarezerwować dwa razy na tę samą godzinę.`)
};

/**
* | output |
* | --- |
* | "Yes. Everyone gets their own hours and their own clients, on one shared schedule, and nobody can be booked twice for the same hour." |
*
* @param {Platform_Faq_Team_AInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_faq_team_a = /** @type {((inputs?: Platform_Faq_Team_AInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Faq_Team_AInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_faq_team_a(inputs)
	return en_platform_faq_team_a(inputs)
});